<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/*
  Global reset only. Each page owns its own header, nav, and layout,
  so nothing here should style elements by tag name.
*/
html,
body {
  margin: 0;
  padding: 0;
  background: #ffffff;
}

#app {
  font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1e2126;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}
</style>
